import api from "./instance";

export const loginStaff = (payload) => api.post("/staff/login-staff", payload);

export const logoutStaff = () => api.post("/staff/logout");

export const forgotPassword = (payload) => api.post("/staff/forgot-password", payload);

export const changePassword = (_staffId, payload) =>
  api.put("/staff/changepassword", payload);

export const deleteAccount = (_staffId) =>
  api.delete("/staff/deleteaccount");
